<script>
import HeaderName from "../../../Comps/General/HeaderName.vue";
import Breadcrumbs from "../../../Comps/General/Breadcrumbs.vue";
import ProcessesController from "../../../Mixins/ProcessesController";
import AccidentReportForm from "../../../Comps/Staff/AccidentReports/AccidentReportForm.vue";

export default {
    name: "Create",
    components: {
        AccidentReportForm,
        Breadcrumbs,
        HeaderName,
    },

    mixins: [ProcessesController],

    data() {
        return {
            bread: [
                {
                    text: "Accident Reports",
                    disabled: false,
                    link: this.route("accident-reports.index"),
                },
                {
                    text: "Create accident report",
                    disabled: true,
                },
            ],
            form: this.$inertia.form({
                affected_id: null,
                affected_type: null,
                affectee_name: null,
                affectee_address: null,
                affectee_occupation: null,
                accident_date: null,
                accident_location: null,
                accident_description: null,
                injury_description: null,
                accident_cause: null,
                accident_prevention: null,
                accident_action: null,
                job_reference: null,
            }),
        };
    },

    methods: {
        create() {
            this.form.post(this.route("accident-reports.store"));
        },
    },
};
</script>

<template>
    <v-container>
        <header-name>Create an accident report</header-name>

        <breadcrumbs :items="bread" />

        <div class="mt-8">
            <accident-report-form v-model="form" @submitForm="create" />
        </div>
    </v-container>
</template>
